import { Stack, Typography } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import CopyButton from '../../../commonUI/CopyButton';
import { CollectionStatusChip } from './CollectionStatusChip';
type CollectionHeaderProps = {
  collectionId?: string;
  hasNoIssues: boolean;
  totalErrors: number;
  totalWarnings: number;
};

export const CollectionHeader = ({
  collectionId,
  hasNoIssues,
  totalErrors,
  totalWarnings,
}: CollectionHeaderProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Typography variant='h6'>{t('Collection Summary')}</Typography>

        {hasNoIssues ? (
          <CollectionStatusChip status='success' label={t('Perfect!')} />
        ) : (
          <Stack direction='row' spacing={1}>
            {totalErrors > 0 && (
              <CollectionStatusChip
                status='error'
                count={totalErrors}
                label={totalErrors.toString()}
              />
            )}
            {totalWarnings > 0 && (
              <CollectionStatusChip
                status='warning'
                count={totalWarnings}
                label={totalWarnings.toString()}
              />
            )}
          </Stack>
        )}
      </Stack>

      {collectionId && (
        <Stack direction='row' spacing={1} alignItems='center'>
          <Typography variant='body2' color='text.primary'>
            ID:
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            {collectionId}
          </Typography>
          <CopyButton textToCopy={collectionId} />
        </Stack>
      )}
    </>
  );
};
